<script setup lang="ts">
import MessageTypesPage from '../features/message-types/MessageTypesPage.vue';
</script>

<template>
  <MessageTypesPage />
</template>
